import {
  isRedesignEnabled,
  isTelex246ProgressBarOptimization,
} from "src/utils/userSegment/features";

export type BuyFlowDesigns = "DEFAULT" | "REDESIGN" | "TELEX246";
export enum Design {
  REDESIGN = "REDESIGN",
  DEFAULT = "DEFAULT",
  TELEX246 = "TELEX246",
}

export function getCurrentDesign(): BuyFlowDesigns {
  if (isRedesignEnabled()) return Design.REDESIGN;
  if (isTelex246ProgressBarOptimization()) return Design.TELEX246;
  return Design.DEFAULT;
}
